export default {
    find() {
        return null;
    },
    parseUrl() {
        return null;
    },
};
